var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgCommentsDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-comments-disabled_svg__cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-comments-disabled_svg__ICN_FComentarii_suprascrieri_Disabled",
    "data-name": "ICN_FComentarii suprascrieri_Disabled",
    transform: "translate(-34 -232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-comments-disabled_svg__Polygon_7",
    "data-name": "Polygon 7",
    d: "M21.679 0a4 4 0 013.473 2.015l5.714 10a4 4 0 010 3.969l-5.714 10A4 4 0 0121.679 28H10.321a4 4 0 01-3.473-2.015l-5.714-10a4 4 0 010-3.969l5.714-10A4 4 0 0110.321 0z",
    transform: "translate(34 232)",
    fill: "#e5e2e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-comments-disabled_svg__Group_1494",
    "data-name": "Group 1494",
    transform: "translate(-987.999 -172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-comments-disabled_svg__Union_12",
    "data-name": "Union 12",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.655 13.193L3.92 11.4H2a2 2 0 01-2-2V1a2 2 0 012-2h12a2 2 0 012 2v8.4a2 2 0 01-2 2H9.4l-1.733 1.793a1.389 1.389 0 01-2.012 0z",
    transform: "translate(1029.999 412.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66 11.932l1.592-1.645.472-.488H14a.4.4 0 00.4-.4V1A.4.4 0 0014 .6H2a.4.4 0 00-.4.4v8.4c0 .22.18.4.4.4h2.598l.471.487 1.592 1.645m0 1.692c-.364 0-.729-.143-1.006-.43L3.92 11.398H2a2 2 0 01-2-2V1A2 2 0 012-1h12a2 2 0 012 2v8.4a2 2 0 01-2 2H9.402l-1.735 1.793a1.394 1.394 0 01-1.006.431z",
    fill: "#fff",
    transform: "translate(1029.999 412.001)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-comments-disabled_svg__Line_64",
    "data-name": "Line 64",
    className: "kpmg-comments-disabled_svg__cls-3",
    transform: "translate(1033.499 419.2)",
    d: "M0 0h8.993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-comments-disabled_svg__Line_65",
    "data-name": "Line 65",
    className: "kpmg-comments-disabled_svg__cls-3",
    transform: "translate(1033.499 415.8)",
    d: "M0 0h4.101"
  })))));
}

export default SvgKpmgCommentsDisabled;